import(/* webpackMode: "eager" */ "/var/www/eduegoo/frontend/node_modules/next/dist/client/link.js");
